import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  accountConnectedTo: {
    defaultMessage: 'You have successfully connected to {providerName}',
    id: 'SuccessOverlay.accountConnectedTo',
  },
});
